import SvgComponent from "../../SVGComponent";

// Suggestions of props for component while using the components -------------------------------------
/**
 * @typedef {((e: React.MouseEvent<HTMLButtonElement, MouseEvent>?) => void)} OnClickEventHandler
 */
/**
 * @typedef {("button" | "submit")} BtnType
 * @typedef {("white" | "black")} HoverOption
 * @param {Object} props
 * @param {BtnType} props.btnType - One of "button" or "submit"
 * @param {OnClickEventHandler} props.handleFunction - What to do when click on button
 * @param {boolean} props.isDisabled
 * @param {String} props.enabledBgColor - Color of bg when button is enabled (var only)
 * @param {String} props.disabledBgColor - Color of bg when button is disabled (var only)
 * @param {boolean} props.isLoading - Is something relevant loading right now (loading state)
 * @param {String} props.icon - Takes svg as an props
 * @param {HoverOption} props.hoverOption - Hover Option Black or White
 * @param {Object} props.buttonRef - Button ref (optional) eg:- state of button ref
 * @param {String} props.title - title/tooltip of the button
 * @param {String} props.imgColor - Takes svg color as an props
 * @returns {JSX.Element}
 */
const IconRoundButton = ({
  btnType,
  handleFunction,
  isDisabled,
  enabledBgColor,
  disabledBgColor,
  isLoading,
  icon,
  hoverOption,
  buttonRef,
  title,
  imgColor,
  iconSize,
}) => {
  return (
    <button
      title={title}
      ref={buttonRef ? buttonRef : null}
      type={btnType !== null ? btnType : "button"}
      onClick={(e) => {
        if (!isLoading) handleFunction(e);
      }}
      className={`flex z-z-index-base relative justify-center items-center p-padding-sm h-icon-lg rounded-border-radius-md w-icon-lg cursor-${
        isDisabled
          ? "not-allowed opacity-light-opacity "
          : `pointer ${
              hoverOption === "white"
                ? "global-hover-white"
                : "global-hover-black"
            }`
      }`}
      style={{
        backgroundColor:
          isDisabled && disabledBgColor
            ? disabledBgColor.toString()
            : enabledBgColor.toString(),
      }}
    >
      <div className="flex flex-row items-center gap-gap-sm">
        <SvgComponent
          color={imgColor}
          height={iconSize ? iconSize : "var(--icon-xs)"}
          width={iconSize ? iconSize : "var(--icon-xs)"}
          url={icon}
          alt="Icon"
        />
      </div>
    </button>
  );
};

export default IconRoundButton;
